import { useEffect, useMemo } from 'react';
import useNdr from '../../../hooks/useNdr';
import { ABD_INCLUDES, buildBaselineAndFilter, buildBaselineOrFilter, fmt } from './constants';

const DEFAULT_SORT = { field: 'awbRegisteredDate', direction: 'DESC' };

export default function useAppointmentSearch({
    filters = {},
    extraAndFilter = [],
    extraOrFilter = [],
    page = 0,
    sizePerPage = 50,
    // Default to fetching count so pagination shows real totals instead of "many".
    // Pages can opt out (skipCount=true) when count is genuinely uninteresting.
    skipCount = false,
    reload = 0,
    sort = DEFAULT_SORT,
}) {
    const extraAndKey = JSON.stringify(extraAndFilter);
    const sortKey = JSON.stringify(sort);
    const extraOrKey = JSON.stringify(extraOrFilter);
    const filtersKey = JSON.stringify({
        awb: filters.awb || '',
        city: filters.city || '',
        state: filters.state || '',
        merchant: filters.merchant || '',
        courier: filters.courier || '',
        reference: filters.reference || '',
        attempts: filters.attempts || '',
        missCategory: filters.missCategory || '',
        fromDate: fmt(filters.fromDate),
        toDate: fmt(filters.toDate),
    });

    const request = useMemo(() => {
        // Use shared baseline builders so grid scope == dashboard scope.
        const andfilter = [...buildBaselineAndFilter(filters), ...extraAndFilter];
        const orfilter = [...buildBaselineOrFilter(filters), ...extraOrFilter];

        return {
            andfilter,
            orfilter,
            offset: page * sizePerPage,
            limit: sizePerPage,
            skipCount,
            includes: ABD_INCLUDES,
            sort,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtersKey, extraAndKey, extraOrKey, sortKey, page, sizePerPage, skipCount, reload]);

    const result = useNdr({ request });

    // RTK Query caches by serialized arg shape; `reload` doesn't appear in the
    // request body, so a reload bump alone wouldn't bust the cache. Force-refetch.
    // Delay accounts for Mongo write→secondary-read replication lag (allowSecondaryReads).
    useEffect(() => {
        if (reload > 0 && result.refetch) {
            const t = setTimeout(() => result.refetch(), 800);
            return () => clearTimeout(t);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload]);

    return { ...result, request };
}
